import type { IconData } from '@stacksjs/iconify-core'

export const zoomInSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22 1.5C10.678 1.5 1.5 10.678 1.5 22S10.678 42.5 22 42.5a20.4 20.4 0 0 0 10.668-2.991q.437.523.87 1.047l.13.156c1.258 1.517 2.516 3.035 3.898 4.535c1.947 2.114 5.044 2.429 7.194.331a46 46 0 0 0 .819-.818c2.097-2.15 1.782-5.247-.332-7.194c-1.5-1.382-3.018-2.64-4.535-3.897l-.157-.13l-1.047-.87A20.4 20.4 0 0 0 42.5 22c0-11.322-9.178-20.5-20.5-20.5M35 22c0 7.18-5.82 13-13 13S9 29.18 9 22S14.82 9 22 9s13 5.82 13 13m-13-8.5a2.5 2.5 0 0 1 2.5 2.5v3.5H28a2.5 2.5 0 0 1 0 5h-3.5V28a2.5 2.5 0 0 1-5 0v-3.5H16a2.5 2.5 0 0 1 0-5h3.5V16a2.5 2.5 0 0 1 2.5-2.5\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default zoomInSolid
